// extracted by mini-css-extract-plugin
export default {"title":"Header_title__cq+Tg","header":"Header_header__M2zQ+","icon":"Header_icon__YCpdR"};